export default {
  iosUrl: "itms-services://?action=download-manifest&url=https://asset.lnyuanyikj.xyz/app/nxl/nxl.plist",
  androidUrl: "https://asset.lnyuanyikj.xyz/app/nxl/nxl.apk",
  apiDomain: "https://www.lnyuanyikj.xyz",
  sharePrefix: "#nxl#",
};
